import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'
import { Link } from 'gatsby'

export default function Page_Acfbuilder_Wrapper_Content1({ data }) {
    const { content1ButtonText, content1Text, content1ButtonLink, content1Title, content1Image, content1Logo, content1ButtonExternalLink } = data
    return (
        <div className='image-radius-wrap'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-5'>
                        <div className='image-radius-patrn-1 white-circle-ptrn-col'>
                            <GatsbyImage
                                image={getImage(content1Image?.localFile)}
                                alt='image'
                            />
                        </div>
                    </div>
                    <div className='col-md-7'>
                        <div className='image-radius-content'>
                            <div className='row image-r-content-head-row'>
                                <div className='col-md-8'>
                                    <h2 className='heading-level-2 blue-color'>
                                        {content1Title && parser(content1Title)}
                                    </h2>
                                </div>
                                <div className='col-md-4'>
                                    <figure>
                                        <GatsbyImage
                                            image={getImage(content1Logo?.localFile)}
                                            alt='image'
                                        />
                                    </figure>
                                </div>
                            </div>
                            {content1Text && <p>{parser(content1Text)}</p>}
                            {content1ButtonExternalLink ? (
                                <a href={content1ButtonExternalLink} className="btn blue-btn">
                                    {content1ButtonText}
                                </a>
                            ) : content1ButtonLink ? (
                                <Link to={content1ButtonLink.uri} className="btn blue-btn">
                                    {content1ButtonText}
                                </Link>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
